<template>
    <div v-if="user">
        <div class="panel panel-success">

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU CONDOMÍNIO
            </div>
            <div class="panel-body" v-if="user.level === 1" >
                <p>
                    <a :href="'#/condominio'" class="btn btn-info btn-block">NOVO CONDOMÍNIO</a>
                </p>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    props: {
        _id: {
            default: null
        }
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
